import React, { useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { SafeIconButton } from "components/icon-fallback";
import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooterWithButtons,
  useOpenClose,
} from "@evertrue/et-components";
import { fetchDesignationProposalCount } from "apps/proposals/proposal-designations-service";

const RightAlignedFooter = styled(ModalFooterWithButtons)`
  &.et--modal-footer-with-buttons {
    justify-content: flex-end;
  }
`;

const ConfirmDeleteDesignation = ({ field, fieldDisplayName, onDelete }) => {
  const [isOpen, openModal, closeModal] = useOpenClose();
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleOpen = async () => {
    openModal();
    setLoading(true);
    try {
      const result = await fetchDesignationProposalCount(field.id);
      setCount(result);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    closeModal();
    setCount(null);
  };

  const handleDelete = () => {
    onDelete(field);
    handleClose();
  };

  const hasProposals = count !== null && count > 0;

  const renderBody = () => {
    if (loading || count === null) return <p>Loading...</p>;
    if (hasProposals) {
      return (
        <React.Fragment>
          <p>
            {`The ${fieldDisplayName} designation is tied to ${count} ${
              count === 1 ? "proposal" : "proposals"
            } and cannot be deleted.`}
          </p>
          <p style={{ marginTop: "16px" }}>
            {" "}
            You must remove it from all associated proposals before it can be
            deleted.
          </p>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <p>{`The ${fieldDisplayName} designation is not tied to any proposals.`}</p>
        <p style={{ marginTop: "16px" }}>Are you sure you want to delete?</p>
      </React.Fragment>
    );
  };

  const renderFooter = () => {
    if (loading || count === null) return null;
    if (hasProposals) {
      return (
        <RightAlignedFooter
          saveLabel="Close"
          onSubmit={handleClose}
          closeModal={handleClose}
        />
      );
    }
    return (
      <RightAlignedFooter
        saveLabel="Delete"
        cancelLabel="Cancel"
        onSubmit={handleDelete}
        onCancel={handleClose}
        closeModal={handleClose}
      />
    );
  };

  return (
    <React.Fragment>
      <SafeIconButton
        size={1}
        title="Delete designation"
        icon="delete"
        onClick={handleOpen}
      />

      <Modal isOpen={isOpen} closeModal={handleClose} size="small">
        <ModalHeader
          title={
            hasProposals ? "Unable to Delete Designation" : "Are you sure?"
          }
          closeModal={handleClose}
        />
        <ModalBody>{renderBody()}</ModalBody>
        {renderFooter()}
      </Modal>
    </React.Fragment>
  );
};

ConfirmDeleteDesignation.propTypes = {
  field: PropTypes.object.isRequired,
  fieldDisplayName: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default ConfirmDeleteDesignation;
